import { FunctionComponent } from 'react';

import {
  ModalContainer,
  ModalLayoutFullScreen,
} from '@kanda-libs/ks-design-library';

import Header from './Header';
import { MODAL_ID } from './constants';

import OmniSignDocumentsForm from '../../Form';

const Modal: FunctionComponent = () => (
  <ModalContainer id={MODAL_ID}>
    {({ handleClose }) => (
      <ModalLayoutFullScreen noBorder header={<Header onClick={handleClose} />}>
        <div className="-mt-6 flex flex-1 h-full">
          <OmniSignDocumentsForm handleClose={handleClose} />
        </div>
      </ModalLayoutFullScreen>
    )}
  </ModalContainer>
);

export default Modal;
